import React, { PropTypes } from "react";
import MemberCoverageDataTable from "./MemberCoverageDataTable";

const MemberCoveragePage = (props) => {
  return (
    <div className="sub-content member-coverage">
      <MemberCoverageDataTable getMember={props.getMember} />
    </div>
  );
};

MemberCoveragePage.propTypes = {
  getMember: PropTypes.func,
};

export default MemberCoveragePage;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/member/coverage/MemberCoveragePage.js